import React from "react"
import { Box, Paper, Stack, Typography } from "@mui/material"
import SideBarLayout from "../../../layout/side-bar-layout"
import { TITLE_DESIGN_SYSTEM_PAGE } from "../../../../utils/constants"
import CodeViewer from "../../../components/CodeViewer/code-viewer"
import InfoItem from "src/v2/components/InfoCard/Info-item"

const InfoItemDesignSystemPage = () => {
    const TITLE_PAGE = `${TITLE_DESIGN_SYSTEM_PAGE} | Info Item`

    const codeUsage = `import InfoItem from "src/v2/components/InfoCard/Info-item"

// Uso básico
<InfoItem
    label="Cetip"
    value="ABC123"
/>

// Com texto complementar
<InfoItem
    label="Devedor"
    value="Empresa Exemplo S.A."
    optionalText="00.000.000/0001-00"
/>

// Texto complementar com opacidade
<InfoItem
    label="Devedor"
    value="Empresa Exemplo S.A."
    optionalText="00.000.000/0001-00"
    optionalTextOpacity={0.6}
/>

// Texto complementar com label
<InfoItem
    label="Setor"
    value="Financeiro"
    optionalTextLabel="Subsetor"
    optionalText="Bancos"
/>

// Texto complementar com variant específica
<InfoItem
    label="Devedor"
    value="Empresa Exemplo S.A."
    optionalText="00.000.000/0001-00"
    optionalTextOpacity={0.6}
    optionalTextVariant="captionInfo"
/>`

    const codeProps = `type InfoItemProps = {
  label: string,              // Título do campo
  value?: string | number | ReactNode, // Valor principal exibido
  optionalText?: string | number | ReactNode, // Texto complementar opcional
  optionalTextLabel?: string, // Label opcional para o texto complementar
  optionalTextOpacity?: number, // Opacidade do texto complementar
  optionalTextVariant?: string // Variant Typography usada no texto complementar
}`

    return (
        <SideBarLayout header title={TITLE_PAGE} headerTitle={TITLE_PAGE}>
            <Box sx={{ mt: -2 }}>
                <Stack spacing={3}>
                    <Paper>
                        <Box p={3}>
                            <Typography
                                variant="h4"
                                gutterBottom
                                color="common.white"
                            >
                                InfoItem
                            </Typography>

                            <Typography variant="body2" color="text.secondary">
                                Componente utilizado para exibir uma informação
                                em formato de label e valor. Também permite
                                adicionar um texto complementar abaixo do valor
                                principal, como CPF/CNPJ, subsetor ou outra
                                informação secundária.
                            </Typography>

                            <Stack
                                direction="row"
                                spacing={6}
                                flexWrap="wrap"
                                mt={4}
                                useFlexGap
                            >
                                <InfoItem label="Cetip" value="ABC123" />

                                <InfoItem label="ISIN" value="BR0000000000" />

                                <InfoItem
                                    label="Devedor"
                                    value="Empresa Exemplo S.A."
                                    optionalText="00.000.000/0001-00"
                                    optionalTextOpacity={0.6}
                                    optionalTextVariant="captionInfo"
                                />

                                <InfoItem
                                    label="Setor"
                                    value="Financeiro"
                                    optionalTextLabel="Subsetor"
                                    optionalText="Bancos"
                                />
                            </Stack>
                        </Box>
                    </Paper>

                    <Paper>
                        <Box p={3}>
                            <Typography
                                variant="h6"
                                gutterBottom
                                color="common.white"
                            >
                                Uso básico
                            </Typography>

                            <Typography
                                variant="body2"
                                color="text.secondary"
                                paragraph
                            >
                                Utilize o componente para exibir pares de
                                informação como label e valor. O
                                optionalText pode ser usado para informações
                                complementares, mantendo o valor principal em
                                destaque.
                            </Typography>

                            <Paper variant="outlined">
                                <Box p={2}>
                                    <CodeViewer
                                        code={codeUsage}
                                        language="jsx"
                                    />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>

                    <Paper>
                        <Box p={3}>
                            <Typography
                                variant="h6"
                                gutterBottom
                                color="common.white"
                            >
                                Propriedades principais
                            </Typography>

                            <Typography
                                variant="body2"
                                color="text.secondary"
                                paragraph
                            >
                                Interface do componente.
                            </Typography>

                            <Paper variant="outlined">
                                <Box p={2}>
                                    <CodeViewer
                                        code={codeProps}
                                        language="tsx"
                                    />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>
                </Stack>
            </Box>
        </SideBarLayout>
    )
}

export default InfoItemDesignSystemPage